<div class="rebalance-included-portfolio-container">
  <div class="flex-row">
    <div class="flex-column">
      The portfolios listed here will be analyzed when this rebalance is submitted. (Portfolios can also be included in other rebalances.)
    </div>
  </div>
  <div class="flex-row">
    <div class="flex-column full-width-column">
      <div class="flex-portfolios-search-container">
        <div class="search-header-text" [class]="{'disabled-opacity': (data?.isUIAllPort && data?.isUIAllPort === true)}"><strong>Use specific portfolios</strong></div>
        <div class="flex-search-split-container">
          <div class="flex-search-split-container-left"
            [class]="{'disabled-opacity': (data?.isUIAllPort && data?.isUIAllPort === true)}">
            <div class="search-add-container">
              <div class="search-name-header "> Search by name</div>
              <div>
                @if (!disableAddPortFolio) {
                  <irb-dropdown-search-multiple id="incl-prtf-multi-select" #portfolioDropdown
                    [(values)]="portfolioTargets" (search)="getPortfolios($event)" searchOnOpen=true
                    (selection)="onPortfolioChange($event)" [enableHiddenSearchResults]="true"
                    style="width: 300px !important;" size="30">
                  </irb-dropdown-search-multiple>
                }
                @if (disableAddPortFolio) {
                  <select [disabled]='true' class="disableSelectPortfolio select-readonly" placeholder="-Search-">
                    <option value="">-Search-</option>
                  </select>
                }
              </div>
              <div>
                <button (click)="addPortFolioToGrid()"
                  [disabled]="disableAddPortFolio || !hasPortfolioTargets()"
                  class="btn-medium-secondary included-portfolio-btn-add btn-spacer">Add
                </button>
              </div>
            </div>
            <div class="search-add-container">
              <div class="search-name-header "> Search by attributes</div>
              <div>
                <button (click)="ShowMultiplePortFolioSelection()"
                  [disabled]="disableAddPortFolio"
                  class="btn-medium-secondary included-portfolio-btn-add-from-list">Advanced Filter
                </button>
              </div>
            </div>
          </div>
          @if (!(this.data.analysisType === 'Manual adjustment') && !(this.data.analysisType === 'Covered call')) {
            <div class="flex-search-split-container-right">
              <div class="checkbox-rebalance-all">
                <span>
                  <p-checkbox binary="true" [(ngModel)]="data.isUIAllPort"
                    (onChange)="onSelectAllPortFolios($event)"
                  inputId="isUIAllPortfolios"></p-checkbox>
                  <label for="isUIAllPortfolios" style="margin-left: .3rem;">Rebalance All Portfolios</label>
                  <!-- [disabled]="!enableSelectAllPortfoliosFlag" -->
                  <span class="tooltipIcon infoIcon rebalance-all-icon" calltoaction
                  [calltoactionTemplate]="rebalanceAllTemplate"></span>
                </span>
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  </div>
  <div class="flex-row overlap-top-margin flex-horizontal-divider">
    <div class="flex-column full-width-column">
      <div class="flex-portfolios-search-container">
        <div class="search-header-text"  [class]="{'disabled-opacity': (data?.isUIAllPort && data?.isUIAllPort === true)}">
          <span><img src="/assets/images/lighting_bolt_smartfilter.png" class="auto-filter-lighting-icon"><strong> Auto-Filter to include portfolios meeting all of these criteria:</strong>
          <span class="tooltipIcon infoIcon trade-explanation-icon" calltoaction
            [calltoactionTemplate]="rebalInfoAutoFIlter">
          </span>
        </span>
      </div>
      <div style="display:flex;" [class]="{'disabled-opacity': (data?.isUIAllPort && data?.isUIAllPort === true)}">
        <div style="padding: 5px 10px 0 0;">
          <div class="dropdown-title" >Model</div>
          <div class="dropdown-title" style="padding-top: 25px;">{{portfolioCustLabelAbbr}}</div>
        </div>
        <div>
          <div style="padding: 5px 0 15px 0;">
            @if (!disableAddPortFolio) {
              <irb-dropdown-search-multiple #modelDropDown [(values)]="modelTargets"
                (search)="getModels($event)"
                searchOnOpen=true keepChecks="true" [enableEmptySearchTerm]="true"
                applyOnClear="true"
                (selection)="onModelChange($event)" style="width: 300px !important;"
              size="30" showApplyButton="true" (applySelection)="addSmartFilterPortfolios()"></irb-dropdown-search-multiple>
            }
            @if (disableAddPortFolio) {
              <select [disabled]='true' class="select-readonly" placeholder="-Search-">
                <option value="">-Search-</option>
              </select>
            }
          </div>
          <div>
            @if (!disableAddPortFolio) {
              <irb-dropdown-search-multiple #categoryDropdown [(values)]="categoryTargets"
                (search)="getCategories($event)"
                searchOnOpen=true keepChecks="true" [enableEmptySearchTerm]="true"
                applyOnClear="true"
                (selection)="oncategoryChange($event)" style="width: 300px !important;"
              size="30" showApplyButton="true" (applySelection)="addSmartFilterPortfolios()"></irb-dropdown-search-multiple>
            }
            @if (disableAddPortFolio) {
              <select [disabled]='true' class="select-readonly" placeholder="-Search-">
                <option value="">-Search-</option>
              </select>
            }
          </div>
        </div>





        <div class="middle-left">
          <div class="flex-auto-filter-container flex-inner-container">
            <div class="flex-element-group-control">
              <label>Not rebalanced in</label>&nbsp;
              <irb-number-text-box [(value)]="data.smartFilterDto.smartFilterDays" min="1"
                max="999" invalidMessage="Please enter only numbers"
                [disabled]="disableAddPortFolio"  [isPercentage]="false"
                invalidRangeMessage="Please enter only numbers between 1 and 999."
              [disabled]="modelUpdated" width="50px"></irb-number-text-box>
              &nbsp;days(1-999)
              <label class="tooltipIcon infoIcon trade-explanation-icon" calltoaction
              [calltoactionTemplate]="rebalInfoNotRebalancedIn"></label>
            </div>
            <div class="flex-element-group-control-and-or"><label class="or-text">-OR-</label></div>
            <div class="flex-element-group-control flex-inner-checkBox">
              <div class="checkboxes-horizontal-align">
                <div class="flex-checkbox-item">
                  <p-checkbox binary="true" [(ngModel)]="modelUpdated" (onChange)="onSelectPortFoliosModels($event)" [disabled]="disableAddPortFolio"
                  inputId="portModelsChanged"></p-checkbox>
                  <label for="portModelsChanged" style="margin-left: .3rem;">Portfolios whose models have changed</label>
                </div>
              </div>
            </div>
          </div>

        </div>
        <div class="last-left">
          <div class="flex-element-group-control">
            <button class=" btn-medium-secondary" style="width: 135px;" (click)="addSmartFilterPortfolios()" >Apply
            </button>
          </div>

          <div class="flex-element-group-control">
            <button class="btn-medium-tertiary" (click)="clearAutoFilter()">Clear Auto-filters
            </button>
          </div>

        </div>
      </div>


    </div>
  </div>
  <div class="flex-row flex-row-counter-buttons">
    <div class="flex-column flex-column-counter-buttons">

      <div class="portfolio-counter flex-button-group">{{rowCountText}}</div>
      <!--div class="flex-button-group" *ngIf="hideImportExtraCashAndColDefs &&  !(data?.isUIAllPort && data?.isUIAllPort === true) && rowCount >0">
      <div  class="flex-expand-collapse">
        [<a (click)="expandAll()" *ngIf="!this.isExpandedAll" >Expand All</a><span  *ngIf="this.isExpandedAll">Expand All</span>
        &nbsp;/
        <a (click)="collapseAll()"  *ngIf="!this.isCollapsedAll"> Collapse All</a><span  *ngIf="this.isCollapsedAll"> Collapse All</span>]

      </div>
    </div-->
    <div  class="flex-button-group"  [class]="{'disabled-opacity': (data?.isUIAllPort && data?.isUIAllPort === true)}">
      @if (hideImportExtraCashAndColDefs) {
        <button class="btn-medium-secondary" (click)="showImportExtraCashDialog()"
        [disabled]="disableAddPortFolio">Import extra cash settings</button>
      }
      @if (data.analysisType==='Tax Loss Harvest') {
        <button class="btn-medium-secondary"
        (click)="showImportLossPrioritySettingsDialog()" [disabled]="disableAddPortFolio">Import Loss Priority settings</button>
      }
    </div>
  </div>
  <!--<div class="flex-column" *ngIf="hideImportExtraCashAndColDefs &&  !(data?.isUIAllPort && data?.isUIAllPort === true) && rowCount >0">-->
  <!--<div class="extra-cash-notes">If Extra Cash entry fields are not visible, use the expand-row device preceding the > portfolio name</div></div>-->
</div>
</div>
@if (!isUnitTest) {
  <irb-inventory-grid id="rebalance-included-portfolio-grid"
    [style.width]="'100%'"
    [style.minHeight]="'150px'"
    [style.height]="gridHeight"
    [showSideBar]="false"
    [gridOptions]="gridOptions"
    [frameworkComponents]="frameworkComponents"
    (gridReady)="onGridReady($event)"
  ></irb-inventory-grid>
}
<ng-template #rebalInfoNotRebalancedIn>
  <div>
    If a portfolio had the indicated type of rebalance run within the number of days specified, iRebal won't include the portfolio in this list.
  </div>
</ng-template>
<ng-template #rebalInfoAutoFIlter>
  <div class="block">Choose the criteria to filter portfolios. The auto filter picks portfolios every time a rebalance runs, so you don't see a static list or have to re-run the filter to capture new portfolios. Multiple labels used as a auto filter will include any portfolio containing any label selected, and does not require a portfolio to have all labels.  Adding and removing labels from portfolios will affect which portfolios are included in rebalances.</div>
  <div>Auto-filtered portfolios are indicated in the grid by<img src="/assets/images/lighting_bolt_smartfilter.png"></div>
</ng-template>
<ng-template #rebalanceAllTemplate>
  <div>
    This includes all portfolios every time a rebalance runs, so you don't see a static list or have to re-run the filter to capture new portfolios.
  </div>
</ng-template>
</div>
